import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { MenuOutlined } from '@ant-design/icons'

const PatternTableRow = ({ children, index, record, ...restProps }) => {
    if (!record) return null
    return (
        <Draggable key={record.id.toString()} draggableId={record.id.toString()} index={index}>
            {provided => (
                <tr key={record.id} ref={provided.innerRef} {...restProps} {...provided.draggableProps}>
                    {React.Children.map(children, child => {
                        if (child.key === 'sort') {
                            return React.cloneElement(child, {
                                children: (
                                    <div
                                        className='DragHandle d-flex-center m-8'
                                        title='reorder pattern'
                                        {...provided.dragHandleProps}
                                    >
                                        <MenuOutlined />
                                    </div>
                                ),
                            })
                        }
                        return child
                    })}
                </tr>
            )}
        </Draggable>
    )
}

export default PatternTableRow
